// Deep links to a payment request (/pay/:requestId, emailed to the payer).
// A logged-out visit, an expired session or "sign out and switch account" goes
// to the parent login and comes back to the pay page afterwards. Modelled on
// src/Organizer/Oireachtas/panelLink.js: only a pay path (pathname, no query)
// is ever remembered or honoured, so the stored value can't become an open
// redirect.
const KEY = "payReturnPath";
const PAY_PATH = /^\/pay\/[a-f0-9]{24}\/?$/;

export const isPayPath = (pathname) => PAY_PATH.test(String(pathname || ""));

export function rememberPayPath(pathname) {
  if (!isPayPath(pathname)) return;
  try {
    sessionStorage.setItem(KEY, pathname);
  } catch (e) {
    /* storage unavailable: the payer opens the emailed link again */
  }
}

// Read once and clear; returns null unless it is a pay path.
export function takePayReturnPath() {
  let path = null;
  try {
    path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
  } catch (e) {
    return null;
  }
  return isPayPath(path) ? path : null;
}

// On a pay page any 401/403 means the stored session no longer works (the pay
// API never answers "not yours" with 403), so the payer is sent to log in and
// returned here instead of being dropped on the home page.
export function payPathSessionEnded(status, pathname) {
  if (!isPayPath(pathname)) return false;
  return status === 401 || status === 403;
}
